﻿import { $$, isVisible } from '@/Utils';
import { DataAttributes } from "@/enums"
import {getPhoneInstanceAndInitIfNotExists} from '@/Phone';
import  { Iti } from "intl-tel-input";

function setInputStyleValid(elem: HTMLElement) {
    if ((elem as HTMLInputElement)?.type === "checkbox") {
        elem.classList.add("input-validation-valid");
        elem.classList.remove("input-validation-error");
        elem = elem.closest(".checkbox");
    }
    elem.classList.add("input-validation-valid");
    elem.classList.remove("input-validation-error");
}

function setInputStyleInvalid(elem: HTMLElement) {
    if ((elem as HTMLInputElement)?.type === "checkbox") {
        elem.classList.remove("input-validation-valid");
        elem.classList.add("input-validation-error");
        elem = elem.closest(".checkbox");
    }
    elem.classList.remove("input-validation-valid");
    elem.classList.add("input-validation-error");
}

export function handleError(elem: HTMLElement, message: string) {
    setInputStyleInvalid(elem);
    const name = elem.getAttribute("name");
    const validationMessages = $$(`[data-valmsg-for="${name}"]`);
    validationMessages.forEach(validationMessage => {
        if (message)
            validationMessage.innerHTML = message;
        validationMessage.classList.remove("field-validation-valid");
        validationMessage.classList.add("field-validation-error");
    });
}

export function handleSuccess(elem: HTMLElement) {
    setInputStyleValid(elem);
    const validationMessages = $$(`[data-valmsg-for="${elem.getAttribute("name")}"]`);
    validationMessages.forEach(validationMessage => {
        validationMessage.textContent = null;
        validationMessage.classList.add("field-validation-valid");
        validationMessage.classList.remove("field-validation-error");
    });
}

function addressFieldsAreEmpty(form: HTMLFormElement): boolean{
    let isEmpty = true;
    form.querySelectorAll(".manual-address [data-val]").forEach((x: HTMLInputElement) => {
        if (x.value.length > 0) {
            isEmpty = false;
        }
    });
    return isEmpty;
}

export function validateForm(form: HTMLFormElement, exemptions?: string[]): boolean {
    let valid = true;
    
    if(form.id == "contactInfoForm" && addressFieldsAreEmpty(form) === true) {
        let addressExemptions = ["AddressInfo_PostalCode", "AddressInfo_Address", "AddressInfo_Settlement","AddressInfo_City","AddressInfo_County"];
        exemptions = exemptions ? exemptions.concat(addressExemptions) : addressExemptions;
    }
    
    form.querySelectorAll("[data-val]").forEach((x: HTMLElement) => {
        if (exemptions && exemptions.includes(x.id)) return;
        valid = validateElement(x) && valid;
    });
    form.querySelectorAll("[data-radio-required]").forEach((x: HTMLElement) => validateRadioList(x));

    const reCaptcha = form.elements["g-recaptcha-response"] as HTMLTextAreaElement;
    if (reCaptcha) {
        if (reCaptcha.value) {
            valid = true;
            $$(".g-recaptcha").forEach(x => setInputStyleValid(x));
        } else {
            valid = false;
            $$(".g-recaptcha").forEach(x => setInputStyleInvalid(x));
        }
    }
    form.querySelectorAll("[data-val].input-validation-error").forEach(x => {
        if (exemptions && exemptions.includes(x.id)) return;
        valid = false;
    });
    return valid;
}

export function validateElement(elem: HTMLElement): boolean {
    const isCheckbox = (elem as HTMLInputElement)?.type === "checkbox";
    const elemSibling = (elem.nextElementSibling as HTMLElement);
    const dropdown = elemSibling?.classList.contains("dropdown") ? elemSibling : null;
    const elemForIsVisibleCheck = isCheckbox ? elem.closest(".checkbox") : (dropdown || elem);

    if (!isVisible(elemForIsVisibleCheck as HTMLElement)) {
        handleSuccess(elem);
        return true;
    }
    let value = "";
    switch (elem.constructor) {
        case HTMLInputElement:
            const input = elem as HTMLInputElement;
            value = isCheckbox ? (input.checked ? "1" : "0") : input.value;
            break;
        case HTMLTextAreaElement:
            value = (elem as HTMLTextAreaElement).value;
            break;
        case HTMLSelectElement:
            value = (elem as HTMLSelectElement).value;
        // TODO: teised juhud
    }
    //const isVal = elem.getAttribute("data-val") === "true";
    const custom = elem.getAttribute("data-val-custom");
    const required = elem.getAttribute("data-val-required");
    const range = elem.getAttribute("data-val-range");
    const rangeMin = parseFloat(elem.getAttribute("data-val-range-min"));
    const rangeMax = parseFloat(elem.getAttribute("data-val-range-max"));

    const minLengthMin = parseInt(elem.getAttribute("data-val-minlength-min"));
    const maxLength = elem.getAttribute("data-val-maxlength");
    const maxLengthMax = parseInt(elem.getAttribute("data-val-maxlength-max"));
    const regex = elem.getAttribute("data-val-regex");
    const regexPattern = elem.getAttribute("data-val-regex-pattern");
    const numeric = elem.getAttribute("data-val-number");

    if (required && !value) {
        handleError(elem, custom || required);
        return false;
    }

    if (range) {
        const number = parseFloat(value);
        if (isNaN(number) || number < rangeMin || number > rangeMax) {
            handleError(elem, custom || range);
            return false;
        }
    }
    if (custom && value.length < minLengthMin) {
        handleError(elem, custom);
        return false;
    }

    if (maxLength && value.length > maxLengthMax) {
        handleError(elem, custom || maxLength);
        return false;
    }
    if ((required && !value || value) && regex && !(new RegExp(regexPattern).test(value))) {
        handleError(elem, custom || regex);
        return false;
    }

    if (numeric) {
        const number = parseFloat(value);
        if (isNaN(number)) {
            handleError(elem, custom || numeric);
            return false;
        }
    }

    if (elem.hasAttribute(DataAttributes.Phone)) {
        const input = elem as HTMLInputElement;
        const iti = getPhoneInstanceAndInitIfNotExists(input)
        const dialCode = iti.getSelectedCountryData().dialCode
        const isValid = !required && !value || !required && value === "+" + dialCode || iti.isValidNumber(value, "")
        
        if (!isValid) {
            handleError(elem, custom);
            return false;
        }
        
        // getNumber() performs some silent validation - for example in LT phone numbers: +37086... -> +3706...
        input.value = iti.getNumber()
    }

    handleSuccess(elem);
    return true;
}

export function validatePhoneNumber(elem: HTMLInputElement, iti: Iti) {
    const countryData = iti.getSelectedCountryData();
    if(!elem.value.startsWith("+") && elem.value){
        elem.value = "+" + countryData.dialCode + elem.value;
    }
    const isValid = !elem.value || elem.value === "+" + countryData.dialCode || iti.isValidNumber();
    if (isValid) {
        elem.value = elem.value.replace(/\s/g, "");
        handleSuccess(elem);
    } else {
        if (elem.value !== iti.getNumber()) {
            elem.parentNode.querySelector(".iti__flag").classList.remove(`iti__${countryData.iso2}`);
        }
        const custom = elem.getAttribute("data-val-custom");
        handleError(elem, custom);
    }
}

export function initInputListeners() {
    $$("[data-val]").forEach(x => {
        x.addEventListener("change",
            x => {
                validateElement(x.target as HTMLElement);
                $$(".alert-validation--active").forEach(a => a.classList.remove("alert-validation--active"));
            });
    });

    $$(".custom-radio__input ").forEach(x => {
        const list = x.closest("[data-radio-required]") as HTMLElement;
        if (list) {
            x.addEventListener("change", () => validateRadioList(list))
        }
    })
}

export function validateRadioList(list: HTMLElement) {
    const hasChecked = list.querySelectorAll(".custom-radio__input:checked").length;
    if (hasChecked) {
        handleSuccess(list);
    } else {
        const message = list.getAttribute("data-val-custom");
        handleError(list, message);
    }
}
